module.exports = __webpack_public_path__ + "static/media/device-disconnected.e1b55756.svg";